module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-60262646!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plSpinner/plSpinner.vue
// module id = 2374
// module chunks = 61